import { Controller } from 'stimulus'
let lastScrollTop = 0

export default class HeaderController extends Controller {
  static targets = [
    'mobileburgermenu',
    'mobilemenu',
    'container',
    'submenu',
    'mobilemenubutton'
  ]

  connect() {
    if (document.body.classList.contains('stallion-template-default')) {
      this.containerTarget.style.background = document.querySelector('#js-theme-color').value
    } 
    this.onPageScrollBind = this.onPageScroll.bind(this)
    window.addEventListener("scroll", this.onPageScrollBind)
    this.onPageScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onPageScrollBind)
  }

  onPageScroll() {
    if (window.innerWidth > 800) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // If scrolled more than 200px, add class to body called "js-nav-scrolling"
      if (scrollTop > 100) {
          document.body.classList.add("js-nav-scrolling");
      } else {
          document.body.classList.remove("js-nav-scrolling");
      }

      // Check if scrolling down
      if (scrollTop > lastScrollTop && scrollTop > 500) {
          document.body.classList.add("js-nav-scrolling-down");
      } else {
          document.body.classList.remove("js-nav-scrolling-down");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    } else {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // If scrolled more than 200px, add class to body called "js-nav-scrolling"
      if (scrollTop > 100) {
          document.body.classList.add("js-nav-scrolling");
      } else {
          document.body.classList.remove("js-nav-scrolling");
      }
    }
}

  toggleMobileMenu() {
    this.mobileburgermenuTarget.classList.toggle('close')
    this.mobilemenuTarget.classList.toggle('overlay')
  }

  showSubmenu(e) {
    const key = e.currentTarget.getAttribute('submenu')
    this.submenuTargets.forEach((el) => {
      el.classList.remove('active')
    })
    this.submenuTargets.find((el) => el.getAttribute('submenu') == key).classList.add('active')
  }

  hideSubmenu() {
    this.submenuTargets.forEach((el) => {
      el.classList.remove('active')
    })
  }

  toggleMobileSubmenu(event) {
    console.log('toggleMobileSubmenu')
    event.preventDefault();
    const button = event.currentTarget;
    const submenuName = button.getAttribute('data-submenu');
    const submenu = this.submenuTargets.find(el => el.getAttribute('data-submenu-name') === submenuName);
  
    if (submenu.classList.contains('hidden')) {
      submenu.classList.remove('hidden');
      button.querySelector('svg').classList.add('rotate-180');
    } else {
      submenu.classList.add('hidden');
      button.querySelector('svg').classList.remove('rotate-180');
    }
  }
}
